'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INITIALIZE_PUBSUB = exports.PUBLISH_MESSAGE = undefined;

var _createAsyncActionTypes = require('conversations-async-data/async-action/createAsyncActionTypes');

var PUBLISH_MESSAGE = exports.PUBLISH_MESSAGE = (0, _createAsyncActionTypes.createAsyncActionTypes)('PUBLISH_MESSAGE');
var INITIALIZE_PUBSUB = exports.INITIALIZE_PUBSUB = (0, _createAsyncActionTypes.createAsyncActionTypes)('INITIALIZE_PUBSUB');